import styled from 'styled-components';
import { TableCell } from '@mui/material';
import { Alert } from '@mui/material';
import { StyledProps } from 'types/styled';

export const TruncatedTextTableCell = styled(TableCell)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: pre;
  max-width: 30px;
`;

export const MemberInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}`;

export const MemberFormStyler = styled.div`
  .header-name,
  .header-id {
    word-break: break-all;
  }

  .MuiTextField-root {
    margin-bottom: 1rem;
  }
`;

export type CellWithBorderClassNames =
  | 'show-border'
  | 'show-border-top'
  | 'show-border-bottom'
  | 'show-border-left'
  | 'show-border-right'
  | 'text-centered'
  | 'no-border-bottom'
  | 'no-border-right'
  | 'no-border-top'
  | 'no-border-left'
  | 'sticky'
  | 'zindex3'
  | 'zindex4';

export const CellWithBorder = styled(TableCell)`
  transition: all 0.2s ease;

  &.show-border {
    border: 1px solid
      ${(props: StyledProps) =>
        props.theme.palette.mode === 'dark'
          ? 'rgba(148, 163, 184, 0.15)'
          : 'rgba(226, 232, 240, 0.8)'};
  }

  &.show-border-top {
    border-top: 1px solid
      ${(props: StyledProps) =>
        props.theme.palette.mode === 'dark'
          ? 'rgba(148, 163, 184, 0.15)'
          : 'rgba(226, 232, 240, 0.8)'};
  }

  &.show-border-bottom {
    border-bottom: 1px solid
      ${(props: StyledProps) =>
        props.theme.palette.mode === 'dark'
          ? 'rgba(148, 163, 184, 0.15)'
          : 'rgba(226, 232, 240, 0.8)'};
  }

  &.show-border-left {
    border-left: 1px solid
      ${(props: StyledProps) =>
        props.theme.palette.mode === 'dark'
          ? 'rgba(148, 163, 184, 0.15)'
          : 'rgba(226, 232, 240, 0.8)'};
  }

  &.show-border-right {
    border-right: 1px solid
      ${(props: StyledProps) =>
        props.theme.palette.mode === 'dark'
          ? 'rgba(148, 163, 184, 0.15)'
          : 'rgba(226, 232, 240, 0.8)'};
  }

  &.text-centered {
    text-align: center;
  }

  &.no-border-bottom {
    border-bottom: none;
  }
  &.no-border-right {
    border-right: none;
  }

  &.no-border-top {
    border-top: none;
  }

  &.no-border-left {
    border-left: none;
  }

  &.sticky {
    position: sticky;
    left: 0;
    background-color: ${(props: StyledProps) =>
      props.theme.palette.mode === 'dark' ? 'rgba(15, 23, 42, 0.98)' : 'rgba(248, 250, 252, 0.98)'};
    backdrop-filter: blur(12px);
    z-index: 2;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 1px;
      background: ${(props: StyledProps) =>
        props.theme.palette.mode === 'dark'
          ? 'linear-gradient(180deg, transparent 0%, rgba(148, 163, 184, 0.15) 50%, transparent 100%)'
          : 'linear-gradient(180deg, transparent 0%, rgba(226, 232, 240, 0.8) 50%, transparent 100%)'};
    }
  }

  &.zindex3 {
    z-index: 3;
  }
  &.zindex4 {
    z-index: 4;
  }
`;

export const LinkText = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: ${(props) => props.theme.palette.primary.main};

  &.disabled {
    cursor: unset;
    text-decoration: unset;
    color: ${(props) => props.theme.palette.text.disabled};
  }
`;

export const StyledAlert = styled(Alert)`
  &.icon-only {
    &.MuiAlert-root {
      padding: 0;
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
      display: flex;
      align-items: center;
    }
    background-color: transparent !important;

    .MuiAlert-icon {
      padding: 0 !important;
      margin-right: 0.7rem !important;
      font-size: 1.25rem !important; // 20px - match BrokenLinkIcon size
      width: 1.25rem;
      height: 1.25rem;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      svg {
        font-size: 1.25rem !important; // 20px
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }
  &.inline-block {
    display: inline-block;
  }

  &.remove-icon-padding {
    .MuiAlert-icon {
      padding: 0 !important;
      margin-right: 0.5rem !important;
    }
  }

  &.remove-message-padding {
    .MuiAlert-message {
      padding: 0 !important;
    }
  }

  /* Sidebar-specific styling for integration health icons */
  &.sidebar {
    display: flex;
    align-items: center;

    .MuiAlert-icon {
      font-size: 1.125rem !important; // 18px - match sidebar text size
      margin: 0 !important;

      svg {
        font-size: 1.125rem !important; // 18px
      }
    }
  }

  &.row-flex-center {
    display: flex;
    justify-content: center;
  }

  justify-content: flex-end;

  &.center-with-margin {
    width: fit-content;
    margin: auto;
  }

  &.no-margin-on-icon {
    .MuiAlert-icon {
      margin: 0;
    }
  }
`;
